import React, { useState, useEffect, useCallback } from 'react'
import { useSnackbar } from 'notistack'
import DynamicTable from '../../components/DataTables/DynamicTable'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Spiner from '../../components/General/Spiner'
import { styled } from '@mui/material/styles'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Areas = () => {
  const [spiner, setSpiner] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const [data, setData] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const getArea = useCallback(async (idArea, page, perPage, search = "") => {
    setSpiner(true)
    const resp = await ConfiguracionLogic.areasLogic(idArea, page, perPage, search)
    if (resp.success) {
      setData(resp.data)
      setTotalRows(resp.totalRows)
    }
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
  }, [enqueueSnackbar])

  useEffect(() => {
    getArea(0, 1, 5, '')
  }, [getArea])

  const columns = ['Nombre', 'Id', 'Descripcion', 'Fecha']

  const handleNew = async () => {
    localStorage.setItem('areaIdDetail', 0)
    localStorage.setItem('saveTypeAreas', 'I')
    window.location.href = global.AREAS_CREATE
  }

  const handleEdit = (item) => {
    localStorage.setItem('areaIdDetail', item.id)
    localStorage.setItem('saveTypeAreas', 'E')
    window.location.href = global.AREAS_CREATE
  }

  const handleDelete = (item) => {
    setSelectedItem(item)
    setOpenDeleteModal(true)
  }

  const confirmDelete = async () => {
    if (selectedItem) {
      setSpiner(true)
      const resp = await ConfiguracionLogic.saveEditAreaLogic(selectedItem, '', 'D', '', 0)
      enqueueSnackbar(resp.message, {
        variant: resp.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
      if (resp.success) {
        window.location.reload()
      }
      setSpiner(false)
      setOpenDeleteModal(false)
    }
  }

  const cancelDelete = () => {
    setOpenDeleteModal(false)
  }

  const handlePageChange = (page, perPage) => {
    getArea(0, page, perPage, '')
  }

  const handleSearch = (item) => {
    getArea(0, 1, 5, item)
  }

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1, 4),
  }))


  return (
    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Seguridades</li>
                <li className="breadcrumb-item">Áreas</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <br />
                <div className="card-body">
                  <DynamicTable
                    columns={columns}
                    data={data}
                    onNew={handleNew}
                    headerText="Nueva Área"
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onSearch={handleSearch}
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Dialog
        open={openDeleteModal}
        onClose={cancelDelete}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialogContent-root": {
            overflowY: "hidden", // Esto evitará la barra de desplazamiento
          },
          "& .MuiDialog-paper": {
            maxHeight: "400px", // Ajusta el tamaño máximo del modal si es necesario
          },
        }}
      >
        <DialogTitle>
          Confirmar Eliminación
          <IconButton
            edge="end"
            color="inherit"
            onClick={cancelDelete}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p>¿Estás seguro que deseas eliminar este elemento?</p>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={cancelDelete} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
            Cancelar
          </StyledButton>
          <StyledButton onClick={confirmDelete} sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
            Confirmar
          </StyledButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Areas
